import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService, UtilService, OriginMessageError} from "library";
import {ErrorTemplate, PageErrorTemplate} from "projects/store/src/app/interfaces";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {PixelService} from "projects/store/src/app/services/api/v1/pixel.service";

@Component({
  selector: 'app-sales-error-message',
  templateUrl: './sales-error-message.component.html'
})
export class SalesErrorMessageComponent implements OnInit {
  isV3Theme: boolean = false;
  error!: ErrorTemplate;
  messages: PageErrorTemplate[];
  path: string;
  flowCode: string = this.route.snapshot.params['flow_code'];
  attemptedUrl: string;
  messageError: string;

  constructor(@Inject(DOCUMENT) private document: Document,
              private route: ActivatedRoute,
              private salesWorkflowService: SalesWorkflowService,  private metaPixelService: PixelService,
              private utilService: UtilService,
              private customMessageService: CustomMessageService) {
    this.attemptedUrl = history.state.attemptedUrl;
    this.messageError = history.state.messageError;
    this.messages = [
      { code: 'retry-request', path: 'solicitud-reintentar', template: { caseId: '', image: true, title: 'Hemos tenido un inconveniente con su solicitud',
        message: 'Por favor, vuelva a iniciar', button: { label: 'Volver al inicio', icon: true, iconPos: 'left', ...this.salesWorkflowService.getInitialPath(this.flowCode)}
      }, error: {}},
      { code: 'not-approved-request', path: 'solicitud-no-aprobada', template: { caseId: '', image: true,
        title: 'Evaluación', message: 'Entendemos su interés en obtener este crédito, pero en este momento no podemos aprobarlo. Seguiremos evaluando tu perfil para futuras oportunidades',
        optionalMessage: 'Gracias por confiar en Krediya', button: { label: 'Volver al inicio', icon: true, iconPos: 'left', ...this.salesWorkflowService.getInitialPath(this.flowCode)},
      }, error: { url: this.attemptedUrl, template: { message: this.messageError }  }},
      { code: 'invalid-session', path: 'sesion-invalida', template: { caseId: '', image: true, title: 'Tu sesión es inválida',
        message: 'Por favor, vuelva a iniciar', button: { label: 'Volver al inicio', icon: true, iconPos: 'left', ...this.salesWorkflowService.getAuthenticationErrorPath(this.flowCode)}
      }, error: 'Sesion invalida, Token expirado o no encontrado'},
      { code: '', path: 'punto-de-venta-bloqueado', template: { caseId: '', image: true, title: 'Lo sentimos, no fue posible generar el código por un bloqueo existente',
        message: 'Por favor, vuelva a iniciar', button: { label: 'Volver al inicio', icon: true, iconPos: 'left', ...this.salesWorkflowService.getInitialPath(this.flowCode)},
        }, error: {}},
      { code: 'request-not-available', path: 'solicitud-no-disponible', template: { caseId: '', image: true, title: 'Solicitud no disponible',
        message: 'Lo sentimos, pero está solicitud no puede ser cargada', button: { label: 'Volver al inicio', icon: true, iconPos: 'left', ...this.salesWorkflowService.getInitialPath(this.flowCode)},
      }, error: { url: this.attemptedUrl, template: { message: this.messageError }  }}
    ];
    this.path = this.route.snapshot.params['path']

    let filtered: PageErrorTemplate[] = this.messages.filter(item => item.path == this.path);
    if(filtered !== undefined) {
      // Configurar el error en el CustomMessageService para que lo muestre el componente app-error-message
      this.customMessageService.responseNoticeHandler({error: filtered[0].error}, OriginMessageError.FRONTEND, filtered[0].template);
    }

    this.utilService.disablePageLoading();
  }

  ngOnInit(): void {
    this.detectTheme();
  }

  /**
   * Detecta si el tema activo es V3
   * Busca el elemento link con id 'app-theme' y verifica si apunta a v3-theme.css
   */
  private detectTheme(): void {
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    this.isV3Theme = themeLink?.href?.includes('v3-theme.css') || false;
  }
}
